import React from 'react'

import { Button, Form, Modal } from '_zari/core'
import { ZariContext } from '_zari/context'

import { Formik } from 'formik'

import * as FormGroups from './formGroups'

import * as RolService from 'services/rol.service'

const DuplicarModal = ({ idDuplicado, show, handleClose, reloadTable }) => {
  const __zariContext = React.useContext(ZariContext)

  const formInitialValues = React.useMemo(() => {
    return {
      nombre: ''
    }
  }, [])

  const submitHandler = async data => {
    await RolService.duplicarRol({ id: idDuplicado, ...data })
      .then(() => {
        __zariContext.snack('success', 'Registro Duplicado!')
        reloadTable()
        handleClose()
      })
      .catch(({ data: { error } }) => __zariContext.snack('error', error))
  }

  return (
    <Modal show={show} onHide={handleClose}>
      <Modal.Header>
        <Modal.Title>DUPLICAR</Modal.Title>
      </Modal.Header>
      <Formik initialValues={formInitialValues} onSubmit={submitHandler}>
        {({ errors, touched, isSubmitting, handleSubmit }) => (
          <Form>
            <Modal.Body>
              <FormGroups.NombreFormGroup fIsSubmitting={isSubmitting} iError={errors.nombre} iTouched={touched.nombre} />
            </Modal.Body>
            <Modal.Footer>
              <Button disabled={isSubmitting} color='secondary' onClick={handleClose}>
                Cancelar
              </Button>
              <Button disabled={isSubmitting} onClick={handleSubmit}>
                Duplicar
              </Button>
            </Modal.Footer>
          </Form>
        )}
      </Formik>
    </Modal>
  )
}

export default DuplicarModal
